export const DOCUMENT_ROUTES = {
  LIST: '/documents',
} as const;
